import React from 'react';
import { useI18n } from '../i18n';
import { HelpCircle, Book, Video, MessageCircle, Mail } from 'lucide-react';

const HelpPage: React.FC = () => {
  const { t } = useI18n();
  const helpCategories = [
    {
      icon: Book,
      title: t('documentation'),
      description: t('documentationDesc'),
      link: '#'
    },
    {
      icon: Video,
      title: t('videoTutorials'),
      description: t('videoTutorialsDesc'),
      link: '#'
    },
    {
      icon: MessageCircle,
      title: t('communityForum'),
      description: t('communityForumDesc'),
      link: '#'
    },
    {
      icon: Mail,
      title: t('contactSupport'),
      description: t('contactSupportDesc'),
      link: '#'
    }
  ];

  const faqItems = [
    {
      question: t('faqHowUploadQ'),
      answer: t('faqHowUploadA')
    },
    {
      question: t('faqSupportedTypesQ'),
      answer: t('faqSupportedTypesA')
    },
    {
      question: t('faqHowShareQ'),
      answer: t('faqHowShareA')
    },
    {
      question: t('faqDeletedFilesQ'),
      answer: t('faqDeletedFilesA')
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="p-2 mr-3 bg-purple-50 text-purple-600 rounded-md">
            <HelpCircle size={24} />
          </div>
          <h1 className="text-2xl font-bold text-gray-800">{t('helpCenter')}</h1>
        </div>
      </div>

      {/* Help Categories */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {helpCategories.map((category, index) => (
          <a
            key={index}
            href={category.link}
            className="flex items-start p-6 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 transition-colors"
          >
            <div className="p-3 mr-4 bg-purple-50 text-purple-600 rounded-md">
              <category.icon size={24} />
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900">{category.title}</h3>
              <p className="mt-1 text-sm text-gray-500">{category.description}</p>
            </div>
          </a>
        ))}
      </div>

      {/* FAQ Section */}
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-medium text-gray-800">{t('faq')}</h2>
        </div>
        <div className="divide-y divide-gray-200">
          {faqItems.map((item, index) => (
            <div key={index} className="p-6">
              <h3 className="text-base font-medium text-gray-900">{item.question}</h3>
              <p className="mt-2 text-sm text-gray-500">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Support */}
      <div className="bg-purple-50 border border-purple-100 rounded-lg p-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-medium text-purple-900">{t('needMoreHelp')}</h2>
            <p className="mt-1 text-sm text-purple-700">
              {t('supportAvailable')}
            </p>
          </div>
          <button className="px-4 py-2 text-sm font-medium text-white bg-purple-600 rounded-md hover:bg-purple-700">
            {t('contactSupportAction')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;